import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { getCancellationErrorMessage } from '@/returns/pages/TransactionDetailPage/helpers'
import returnsServices from '@/returns/services/services'

const useCancelStoreCredit = ({ orderId, fetchData, fetchTimeline, setToastInfo, handleChargebackError }) => {
  const { t } = useTranslation()
  const [showCancelStoreCreditDrawer, setShowCancelStoreCreditDrawer] = useState(false)
  const [showFailedCancelStoreCreditModal, setShowFailedCancelStoreCreditModal] = useState(false)
  const [notes, setNotes] = useState('')
  const [issueOriginalPaymentMethod, setIssueOriginalPaymentMethod] = useState(false)

  const { fetchData: cancelStoreCredit, loading: cancellingStoreCredit } = useFetch(returnsServices.cancelStoreCredit, {
    doInitialRequest: false,
  })

  const openCancelStoreCreditDrawer = () => {
    setShowCancelStoreCreditDrawer(true)
  }

  const closeCancelStoreCreditDrawer = () => {
    setShowCancelStoreCreditDrawer(false)
    setNotes('')
    setIssueOriginalPaymentMethod(false)
  }

  const closeFailedCancelStoreCreditModal = () => {
    setShowFailedCancelStoreCreditModal(false)
  }

  const handleCancelStoreCredit = async () => {
    try {
      const response = await cancelStoreCredit({ orderId, notes, issueOriginalPaymentMethod })
      if (response?.is_used) {
        setShowCancelStoreCreditDrawer(false)
        setShowFailedCancelStoreCreditModal(true)
      } else {
        setShowCancelStoreCreditDrawer(false)
        setToastInfo({ show: true, message: t('Crédito en tienda cancelado correctamente'), type: 'success' })
        fetchData()
        fetchTimeline()
      }
    } catch (err) {
      if (handleChargebackError(err)) return

      setToastInfo({
        show: true,
        message: getCancellationErrorMessage(err, t('No se pudo anular el crédito en tienda.')),
        type: 'error',
      })
    }
  }

  return {
    showCancelStoreCreditDrawer,
    openCancelStoreCreditDrawer,
    closeCancelStoreCreditDrawer,
    showFailedCancelStoreCreditModal,
    closeFailedCancelStoreCreditModal,
    handleCancelStoreCredit,
    cancellingStoreCredit,
    notes,
    setNotes,
    issueOriginalPaymentMethod,
    setIssueOriginalPaymentMethod,
  }
}

export default useCancelStoreCredit
